export const Plus = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 11.2308C22 10.8227 21.8379 10.4314 21.5494 10.1429C21.2609 9.8544 20.8696 9.69231 20.4615 9.69231H14.3077V3.53846C14.3077 3.13044 14.1456 2.73912 13.8571 2.4506C13.5686 2.16209 13.1773 2 12.7692 2H11.2308C10.8227 2 10.4314 2.16209 10.1429 2.4506C9.8544 2.73912 9.69231 3.13044 9.69231 3.53846V9.69231H3.53846C3.13044 9.69231 2.73912 9.8544 2.4506 10.1429C2.16209 10.4314 2 10.8227 2 11.2308V12.7692C2 13.1773 2.16209 13.5686 2.4506 13.8571C2.73912 14.1456 3.13044 14.3077 3.53846 14.3077H9.69231V20.4615C9.69231 20.8696 9.8544 21.2609 10.1429 21.5494C10.4314 21.8379 10.8227 22 11.2308 22H12.7692C13.1773 22 13.5686 21.8379 13.8571 21.5494C14.1456 21.2609 14.3077 20.8696 14.3077 20.4615V14.3077H17.3846H20.4615C20.8696 14.3077 21.2609 14.1456 21.5494 13.8571C21.8379 13.5686 22 13.1773 22 12.7692V11.2308Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Minus = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.4615 9H3.53846C2.68879 9 2 9.74619 2 10.6667V12.3333C2 13.2538 2.68879 14 3.53846 14H20.4615C21.3112 14 22 13.2538 22 12.3333V10.6667C22 9.74619 21.3112 9 20.4615 9Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Multiply = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.4541 5.90427C21.7547 5.60001 21.9233 5.18952 21.9233 4.7618C21.9233 4.33408 21.7547 3.9236 21.4541 3.61933L20.304 2.4692C20.0035 2.19113 19.6092 2.03666 19.1999 2.03666C18.7905 2.03666 18.3962 2.19113 18.0957 2.4692L11.9617 8.52659L5.90427 2.4692C5.60001 2.16858 5.18952 2 4.7618 2C4.33408 2 3.9236 2.16858 3.61933 2.4692L2.4692 3.61933C2.16858 3.9236 2 4.33408 2 4.7618C2 5.18952 2.16858 5.60001 2.4692 5.90427L8.60326 12.0383L2.4692 18.0957C2.16858 18.4 2 18.8105 2 19.2382C2 19.6659 2.16858 20.0764 2.4692 20.3807L3.61933 21.5308C3.9236 21.8314 4.33408 22 4.7618 22C5.18952 22 5.60001 21.8314 5.90427 21.5308L11.9617 15.3967L18.0957 21.4541C18.4 21.7547 18.8105 21.9233 19.2382 21.9233C19.6659 21.9233 20.0764 21.7547 20.3807 21.4541L21.5308 20.304C21.8314 19.9997 22 19.5892 22 19.1615C22 18.7338 21.8314 18.3233 21.5308 18.0191L15.3967 11.9617L21.4541 5.90427Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Divide = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3.5C11.1716 3.5 10.5 4.17157 10.5 5C10.5 5.82843 11.1716 6.5 12 6.5C12.8284 6.5 13.5 5.82843 13.5 5C13.5 4.17157 12.8284 3.5 12 3.5ZM9.5 5C9.5 3.61929 10.6193 2.5 12 2.5C13.3807 2.5 14.5 3.61929 14.5 5C14.5 6.38071 13.3807 7.5 12 7.5C10.6193 7.5 9.5 6.38071 9.5 5ZM3.53846 9.5C3.00186 9.5 2.5 9.9839 2.5 10.6667V12.3333C2.5 13.0161 3.00186 13.5 3.53846 13.5H20.4615C20.9981 13.5 21.5 13.0161 21.5 12.3333V10.6667C21.5 9.9839 20.9981 9.5 20.4615 9.5H3.53846ZM1.5 10.6667C1.5 9.50849 2.37572 8.5 3.53846 8.5H20.4615C21.6243 8.5 22.5 9.50849 22.5 10.6667V12.3333C22.5 13.4915 21.6243 14.5 20.4615 14.5H3.53846C2.37572 14.5 1.5 13.4915 1.5 12.3333V10.6667ZM10.5 18C10.5 17.1716 11.1716 16.5 12 16.5C12.8284 16.5 13.5 17.1716 13.5 18C13.5 18.8284 12.8284 19.5 12 19.5C11.1716 19.5 10.5 18.8284 10.5 18ZM12 15.5C10.6193 15.5 9.5 16.6193 9.5 18C9.5 19.3807 10.6193 20.5 12 20.5C13.3807 20.5 14.5 19.3807 14.5 18C14.5 16.6193 13.3807 15.5 12 15.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Equal = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 6.66667C2.5 5.9839 3.00186 5.5 3.53846 5.5H20.4615C20.9981 5.5 21.5 5.9839 21.5 6.66667V8.33333C21.5 9.0161 20.9981 9.5 20.4615 9.5H3.53846C3.00186 9.5 2.5 9.0161 2.5 8.33333V6.66667ZM3.53846 4.5C2.37572 4.5 1.5 5.50849 1.5 6.66667V8.33333C1.5 9.49151 2.37572 10.5 3.53846 10.5H20.4615C21.6243 10.5 22.5 9.49151 22.5 8.33333V6.66667C22.5 5.50849 21.6243 4.5 20.4615 4.5H3.53846ZM2.5 15.6667C2.5 14.9839 3.00186 14.5 3.53846 14.5H20.4615C20.9981 14.5 21.5 14.9839 21.5 15.6667V17.3333C21.5 18.0161 20.9981 18.5 20.4615 18.5H3.53846C3.00186 18.5 2.5 18.0161 2.5 17.3333V15.6667ZM3.53846 13.5C2.37572 13.5 1.5 14.5085 1.5 15.6667V17.3333C1.5 18.4915 2.37572 19.5 3.53846 19.5H20.4615C21.6243 19.5 22.5 18.4915 22.5 17.3333V15.6667C22.5 14.5085 21.6243 13.5 20.4615 13.5H3.53846Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const NotEqual = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.604 14H20.4615C21.3112 14 22 14.7462 22 15.6667V17.3333C22 18.2538 21.3112 19 20.4615 19H12L10.8024 21.6026C10.4828 22.4809 9.52245 22.9377 8.65749 22.6228L7.09134 22.0528C6.22637 21.738 5.78432 20.7708 6.10399 19.8925L6.5 19H3.53846C2.68879 19 2 18.2538 2 17.3333V15.6667C2 14.7462 2.68879 14 3.53846 14H8L8.651 12.4731L9.5 10H3.53846C2.68879 10 2 9.25381 2 8.33333V6.66667C2 5.74619 2.68879 5 3.53846 5H11.5L12.4708 2.39978C12.7905 1.52151 13.7508 1.06475 14.6158 1.37957L16.1819 1.9496C17.0469 2.26442 17.4889 3.23161 17.1693 4.10988L17 5H20.4615C21.3112 5 22 5.74619 22 6.66667V8.33333C22 9.25381 21.3112 10 20.4615 10H15L13.9506 12.9007L13.5 14"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const DoubleBrackets = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 2L4.69742 3.90621C4.24308 4.57111 4 5.35767 4 6.16297V17.837C4 18.6423 4.24307 19.4289 4.69742 20.0938L6 22"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
        />
        <path
          d="M18.4128 1.7179C18.257 1.48991 17.9459 1.43138 17.7179 1.58718C17.4899 1.74297 17.4314 2.0541 17.5872 2.2821L18.4128 1.7179ZM19.3282 3.94371L18.9154 4.2258L19.3282 3.94371ZM19.3282 20.0563L19.741 20.3384L19.3282 20.0563ZM17.5872 21.7179C17.4314 21.9459 17.4899 22.257 17.7179 22.4128C17.9459 22.5686 18.257 22.5101 18.4128 22.2821L17.5872 21.7179ZM17.5872 2.2821L18.9154 4.2258L19.741 3.66161L18.4128 1.7179L17.5872 2.2821ZM19.5 6.10839V17.8916H20.5V6.10839H19.5ZM18.9154 19.7742L17.5872 21.7179L18.4128 22.2821L19.741 20.3384L18.9154 19.7742ZM19.5 17.8916C19.5 18.5606 19.2971 19.2156 18.9154 19.7742L19.741 20.3384C20.2354 19.6149 20.5 18.7635 20.5 17.8916H19.5ZM18.9154 4.2258C19.2971 4.78443 19.5 5.43945 19.5 6.10839H20.5C20.5 5.23646 20.2354 4.38508 19.741 3.66161L18.9154 4.2258Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const DoubleBrace = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.41282 2.2821C7.56862 2.0541 7.51009 1.74297 7.2821 1.58718C7.0541 1.43138 6.74297 1.48991 6.58718 1.7179L7.41282 2.2821ZM5.69742 3.90621L5.2846 3.62412L5.69742 3.90621ZM5.69742 20.0938L6.11024 19.8117L5.69742 20.0938ZM6.58718 22.2821C6.74297 22.5101 7.0541 22.5686 7.2821 22.4128C7.51009 22.257 7.56862 21.9459 7.41282 21.7179L6.58718 22.2821ZM3.85706 11.5486L4.07668 11.9978H4.07668L3.85706 11.5486ZM3.85706 12.4514L4.07668 12.0022H4.07668L3.85706 12.4514ZM6.58718 1.7179L5.2846 3.62412L6.11024 4.18831L7.41282 2.2821L6.58718 1.7179ZM5.2846 20.3759L6.58718 22.2821L7.41282 21.7179L6.11024 19.8117L5.2846 20.3759ZM4.5 6.16297V9.73234H5.5V6.16297H4.5ZM3.63744 11.0994C3.41252 11.2094 3.19376 11.3181 3.02984 11.4033C2.94893 11.4454 2.8753 11.4849 2.8194 11.5174C2.79308 11.5328 2.76029 11.5525 2.73005 11.5739C2.71673 11.5833 2.68892 11.6034 2.65951 11.6314C2.64547 11.6448 2.61745 11.6728 2.58952 11.7133C2.5703 11.7412 2.5 11.8458 2.5 12H3.5C3.5 12.1526 3.4305 12.2553 3.41285 12.2809C3.3865 12.3191 3.36083 12.3444 3.34989 12.3549C3.3267 12.377 3.30811 12.3899 3.30685 12.3907C3.30073 12.3951 3.30338 12.3928 3.32241 12.3817C3.3572 12.3615 3.41382 12.3308 3.49116 12.2906C3.64376 12.2112 3.85352 12.1069 4.07668 11.9978L3.63744 11.0994ZM2.5 12C2.5 12.1542 2.5703 12.2588 2.58952 12.2867C2.61745 12.3272 2.64547 12.3552 2.65951 12.3686C2.68892 12.3966 2.71673 12.4167 2.73005 12.4261C2.76029 12.4475 2.79308 12.4672 2.8194 12.4826C2.8753 12.5151 2.94893 12.5546 3.02984 12.5967C3.19376 12.6819 3.41252 12.7906 3.63744 12.9006L4.07668 12.0022C3.85352 11.8931 3.64376 11.7888 3.49116 11.7094C3.41382 11.6692 3.3572 11.6385 3.32241 11.6183C3.30338 11.6072 3.30073 11.6049 3.30685 11.6093C3.30811 11.6101 3.3267 11.623 3.34989 11.6451C3.36083 11.6556 3.3865 11.6809 3.41285 11.7191C3.4305 11.7447 3.5 11.8474 3.5 12H2.5ZM4.5 14.2677V17.837H5.5V14.2677H4.5ZM3.63744 12.9006C4.16485 13.1584 4.5 13.6888 4.5 14.2677H5.5C5.5 13.2986 4.9398 12.4242 4.07668 12.0022L3.63744 12.9006ZM4.5 9.73234C4.5 10.3112 4.16485 10.8416 3.63744 11.0994L4.07668 11.9978C4.9398 11.5758 5.5 10.7014 5.5 9.73234H4.5ZM6.11024 19.8117C5.71269 19.2299 5.5 18.5417 5.5 17.837H4.5C4.5 18.743 4.77346 19.6279 5.2846 20.3759L6.11024 19.8117ZM5.2846 3.62412C4.77346 4.37213 4.5 5.257 4.5 6.16297H5.5C5.5 5.45833 5.71269 4.77009 6.11024 4.18831L5.2846 3.62412Z"
          fill="#585858"
          className={"icon_fill"}
        />
        <path
          d="M17.4128 1.7179C17.257 1.48991 16.9459 1.43138 16.7179 1.58718C16.4899 1.74297 16.4314 2.0541 16.5872 2.2821L17.4128 1.7179ZM18.3026 3.90621L18.7154 3.62412L18.3026 3.90621ZM18.3026 20.0938L17.8898 19.8117H17.8898L18.3026 20.0938ZM16.5872 21.7179C16.4314 21.9459 16.4899 22.257 16.7179 22.4128C16.9459 22.5686 17.257 22.5101 17.4128 22.2821L16.5872 21.7179ZM20.1429 11.5486L19.9233 11.9978H19.9233L20.1429 11.5486ZM20.1429 12.4514L19.9233 12.0022H19.9233L20.1429 12.4514ZM16.5872 2.2821L17.8898 4.18831L18.7154 3.62412L17.4128 1.7179L16.5872 2.2821ZM17.8898 19.8117L16.5872 21.7179L17.4128 22.2821L18.7154 20.3759L17.8898 19.8117ZM18.5 6.16297V9.73234H19.5V6.16297H18.5ZM19.9233 11.9978C20.1465 12.1069 20.3562 12.2112 20.5088 12.2906C20.5862 12.3308 20.6428 12.3615 20.6776 12.3817C20.6966 12.3928 20.6993 12.3951 20.6932 12.3907C20.6919 12.3899 20.6733 12.377 20.6501 12.3549C20.6392 12.3444 20.6135 12.3191 20.5871 12.2809C20.5695 12.2553 20.5 12.1526 20.5 12H21.5C21.5 11.8458 21.4297 11.7412 21.4105 11.7133C21.3825 11.6728 21.3545 11.6448 21.3405 11.6314C21.3111 11.6034 21.2833 11.5833 21.27 11.5739C21.2397 11.5525 21.2069 11.5328 21.1806 11.5174C21.1247 11.4849 21.0511 11.4454 20.9702 11.4033C20.8062 11.3181 20.5875 11.2094 20.3626 11.0994L19.9233 11.9978ZM20.5 12C20.5 11.8474 20.5695 11.7447 20.5871 11.7191C20.6135 11.6809 20.6392 11.6556 20.6501 11.6451C20.6733 11.623 20.6919 11.6101 20.6932 11.6093C20.6993 11.6049 20.6966 11.6072 20.6776 11.6183C20.6428 11.6385 20.5862 11.6692 20.5088 11.7094C20.3562 11.7888 20.1465 11.8931 19.9233 12.0022L20.3626 12.9006C20.5875 12.7906 20.8062 12.6819 20.9702 12.5967C21.0511 12.5546 21.1247 12.5151 21.1806 12.4826C21.2069 12.4672 21.2397 12.4475 21.27 12.4261C21.2833 12.4167 21.3111 12.3966 21.3405 12.3686C21.3545 12.3552 21.3825 12.3272 21.4105 12.2867C21.4297 12.2588 21.5 12.1542 21.5 12H20.5ZM18.5 14.2677V17.837H19.5V14.2677H18.5ZM19.9233 12.0022C19.0602 12.4242 18.5 13.2986 18.5 14.2677H19.5C19.5 13.6888 19.8351 13.1584 20.3626 12.9006L19.9233 12.0022ZM18.5 9.73234C18.5 10.7014 19.0602 11.5758 19.9233 11.9978L20.3626 11.0994C19.8351 10.8416 19.5 10.3112 19.5 9.73234H18.5ZM18.7154 20.3759C19.2265 19.6279 19.5 18.743 19.5 17.837H18.5C18.5 18.5417 18.2873 19.2299 17.8898 19.8117L18.7154 20.3759ZM17.8898 4.18831C18.2873 4.77009 18.5 5.45833 18.5 6.16297H19.5C19.5 5.257 19.2265 4.37213 18.7154 3.62412L17.8898 4.18831Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const LeftBracket = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 2L11.6974 3.90621C11.2431 4.57111 11 5.35767 11 6.16297V17.837C11 18.6423 11.2431 19.4289 11.6974 20.0938L13 22"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};

export const RightBracket = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4128 1.7179C11.257 1.48991 10.9459 1.43138 10.7179 1.58718C10.4899 1.74297 10.4314 2.0541 10.5872 2.2821L11.4128 1.7179ZM12.3282 3.94371L11.9154 4.2258L12.3282 3.94371ZM12.3282 20.0563L12.741 20.3384H12.741L12.3282 20.0563ZM10.5872 21.7179C10.4314 21.9459 10.4899 22.257 10.7179 22.4128C10.9459 22.5686 11.257 22.5101 11.4128 22.2821L10.5872 21.7179ZM10.5872 2.2821L11.9154 4.2258L12.741 3.66161L11.4128 1.7179L10.5872 2.2821ZM12.5 6.10839V17.8916H13.5V6.10839H12.5ZM11.9154 19.7742L10.5872 21.7179L11.4128 22.2821L12.741 20.3384L11.9154 19.7742ZM12.5 17.8916C12.5 18.5606 12.2971 19.2156 11.9154 19.7742L12.741 20.3384C13.2354 19.6149 13.5 18.7635 13.5 17.8916H12.5ZM11.9154 4.2258C12.2971 4.78443 12.5 5.43945 12.5 6.10839H13.5C13.5 5.23646 13.2354 4.38508 12.741 3.66161L11.9154 4.2258Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const LeftBrace = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.4128 2.2821C14.5686 2.0541 14.5101 1.74297 14.2821 1.58718C14.0541 1.43138 13.743 1.48991 13.5872 1.7179L14.4128 2.2821ZM12.6974 3.90621L12.2846 3.62412L12.6974 3.90621ZM12.6974 20.0938L13.1102 19.8117L12.6974 20.0938ZM13.5872 22.2821C13.743 22.5101 14.0541 22.5686 14.2821 22.4128C14.5101 22.257 14.5686 21.9459 14.4128 21.7179L13.5872 22.2821ZM10.8571 11.5486L11.0767 11.9978H11.0767L10.8571 11.5486ZM10.8571 12.4514L11.0767 12.0022H11.0767L10.8571 12.4514ZM13.5872 1.7179L12.2846 3.62412L13.1102 4.18831L14.4128 2.2821L13.5872 1.7179ZM12.2846 20.3759L13.5872 22.2821L14.4128 21.7179L13.1102 19.8117L12.2846 20.3759ZM11.5 6.16297V9.73234H12.5V6.16297H11.5ZM10.6374 11.0994C10.4125 11.2094 10.1938 11.3181 10.0298 11.4033C9.94893 11.4454 9.8753 11.4849 9.8194 11.5174C9.79308 11.5328 9.76029 11.5525 9.73005 11.5739C9.71673 11.5833 9.68892 11.6034 9.65951 11.6314C9.64547 11.6448 9.61745 11.6728 9.58952 11.7133C9.5703 11.7412 9.5 11.8458 9.5 12H10.5C10.5 12.1526 10.4305 12.2553 10.4129 12.2809C10.3865 12.3191 10.3608 12.3444 10.3499 12.3549C10.3267 12.377 10.3081 12.3899 10.3068 12.3907C10.3007 12.3951 10.3034 12.3928 10.3224 12.3817C10.3572 12.3615 10.4138 12.3308 10.4912 12.2906C10.6438 12.2112 10.8535 12.1069 11.0767 11.9978L10.6374 11.0994ZM9.5 12C9.5 12.1542 9.5703 12.2588 9.58952 12.2867C9.61745 12.3272 9.64547 12.3552 9.65951 12.3686C9.68892 12.3966 9.71673 12.4167 9.73005 12.4261C9.76029 12.4475 9.79308 12.4672 9.8194 12.4826C9.8753 12.5151 9.94893 12.5546 10.0298 12.5967C10.1938 12.6819 10.4125 12.7906 10.6374 12.9006L11.0767 12.0022C10.8535 11.8931 10.6438 11.7888 10.4912 11.7094C10.4138 11.6692 10.3572 11.6385 10.3224 11.6183C10.3034 11.6072 10.3007 11.6049 10.3068 11.6093C10.3081 11.6101 10.3267 11.623 10.3499 11.6451C10.3608 11.6556 10.3865 11.6809 10.4129 11.7191C10.4305 11.7447 10.5 11.8474 10.5 12H9.5ZM11.5 14.2677V17.837H12.5V14.2677H11.5ZM10.6374 12.9006C11.1649 13.1584 11.5 13.6888 11.5 14.2677H12.5C12.5 13.2986 11.9398 12.4242 11.0767 12.0022L10.6374 12.9006ZM11.5 9.73234C11.5 10.3112 11.1649 10.8416 10.6374 11.0994L11.0767 11.9978C11.9398 11.5758 12.5 10.7014 12.5 9.73234H11.5ZM13.1102 19.8117C12.7127 19.2299 12.5 18.5417 12.5 17.837H11.5C11.5 18.743 11.7735 19.6279 12.2846 20.3759L13.1102 19.8117ZM12.2846 3.62412C11.7735 4.37213 11.5 5.257 11.5 6.16297H12.5C12.5 5.45833 12.7127 4.77009 13.1102 4.18831L12.2846 3.62412Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const RightBrace = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="6"
        height="22"
        viewBox="0 0 6 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.41282 0.717905C1.25703 0.489909 0.9459 0.431381 0.717905 0.587178C0.489909 0.742975 0.431381 1.0541 0.587178 1.2821L1.41282 0.717905ZM2.30258 2.90621L2.7154 2.62412L2.30258 2.90621ZM2.30258 19.0938L1.88976 18.8117H1.88976L2.30258 19.0938ZM0.587178 20.7179C0.431381 20.9459 0.489909 21.257 0.717905 21.4128C0.9459 21.5686 1.25703 21.5101 1.41282 21.2821L0.587178 20.7179ZM4.14294 10.5486L3.92332 10.9978H3.92332L4.14294 10.5486ZM4.14294 11.4514L3.92332 11.0022H3.92332L4.14294 11.4514ZM0.587178 1.2821L1.88976 3.18831L2.7154 2.62412L1.41282 0.717905L0.587178 1.2821ZM1.88976 18.8117L0.587178 20.7179L1.41282 21.2821L2.7154 19.3759L1.88976 18.8117ZM2.5 5.16297V8.73234H3.5V5.16297H2.5ZM3.92332 10.9978C4.14648 11.1069 4.35624 11.2112 4.50884 11.2906C4.58618 11.3308 4.6428 11.3615 4.67759 11.3817C4.69662 11.3928 4.69927 11.3951 4.69315 11.3907C4.69189 11.3899 4.6733 11.377 4.65011 11.3549C4.63917 11.3444 4.6135 11.3191 4.58715 11.2809C4.5695 11.2553 4.5 11.1526 4.5 11H5.5C5.5 10.8458 5.4297 10.7412 5.41048 10.7133C5.38255 10.6728 5.35453 10.6448 5.34049 10.6314C5.31108 10.6034 5.28327 10.5833 5.26995 10.5739C5.23971 10.5525 5.20691 10.5328 5.1806 10.5174C5.1247 10.4849 5.05107 10.4454 4.97016 10.4033C4.80624 10.3181 4.58748 10.2094 4.36256 10.0994L3.92332 10.9978ZM4.5 11C4.5 10.8474 4.5695 10.7447 4.58715 10.7191C4.6135 10.6809 4.63917 10.6556 4.65011 10.6451C4.6733 10.623 4.69189 10.6101 4.69315 10.6093C4.69927 10.6049 4.69662 10.6072 4.67759 10.6183C4.6428 10.6385 4.58618 10.6692 4.50884 10.7094C4.35624 10.7888 4.14648 10.8931 3.92332 11.0022L4.36256 11.9006C4.58748 11.7906 4.80624 11.6819 4.97016 11.5967C5.05107 11.5546 5.1247 11.5151 5.1806 11.4826C5.20691 11.4672 5.23971 11.4475 5.26995 11.4261C5.28327 11.4167 5.31108 11.3966 5.34049 11.3686C5.35453 11.3552 5.38255 11.3272 5.41048 11.2867C5.4297 11.2588 5.5 11.1542 5.5 11H4.5ZM2.5 13.2677V16.837H3.5V13.2677H2.5ZM3.92332 11.0022C3.0602 11.4242 2.5 12.2986 2.5 13.2677H3.5C3.5 12.6888 3.83515 12.1584 4.36256 11.9006L3.92332 11.0022ZM2.5 8.73234C2.5 9.70136 3.0602 10.5758 3.92332 10.9978L4.36256 10.0994C3.83515 9.84157 3.5 9.31116 3.5 8.73234H2.5ZM2.7154 19.3759C3.22654 18.6279 3.5 17.743 3.5 16.837H2.5C2.5 17.5417 2.28731 18.2299 1.88976 18.8117L2.7154 19.3759ZM1.88976 3.18831C2.28731 3.77009 2.5 4.45833 2.5 5.16297H3.5C3.5 4.257 3.22654 3.37213 2.7154 2.62412L1.88976 3.18831Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};
